import jsPDF from 'jspdf'
import 'jspdf-autotable'

const PDF_EXTENSION = ".pdf";

const maxHeaderColumns = 7;

export function exportToPdf(tableJson, fields, filename) {

  let doc;
  let header = [];
  if(!fields)
    Object.keys(tableJson[0]).forEach(value =>{
      header.push({
        header: value,
        dataKey: value
      });
    });
  else {
    fields.forEach((value, index) =>{
      if(value.key != "acciones")
        header.push({
          header: value.label,
          dataKey: value.key
        });
    });
  }

  if(header.length > 7)
    doc = new jsPDF('landscape')
  else doc = new jsPDF()

  let style = {};
  if(header.length > maxHeaderColumns)
    style = { cellPadding: 0.5, fontSize: 6 };
    
  doc.autoTable({ 
    body: tableJson,
    columns: header,
    styles: style,
  })

  doc.save(filename + PDF_EXTENSION)

}